export default {
  'alerts.date': 'Data wystąpienia',
  'alerts.defect.value': '{defectName}: {value}',
  'alerts.defects': 'Wartości wad',
  'common.1day': '1 dzień',
  'common.1hour': '1 godzina',
  'common.10minutes': '10 minut',
  'common.actions': 'Akcje',
  'common.add.failure': 'Dodawanie nie powiodło się',
  'common.add.success': 'Dodano pomyślnie',
  'common.charts': 'Wykresy',
  'common.charts.addToReport': 'Dodaj do raportu',
  'common.close': 'Zamknij',
  'common.count': 'Ilość',
  'common.createdAt': 'Data utworzenia',
  'common.date': 'Data',
  'common.dateRange': 'Zakres dat',
  'common.dayComparison': 'Porównanie dni',
  'common.defectSet': 'Zestaw wad',
  'common.defectType': 'Rodzaj wady',
  'common.delete': 'Usuń',
  'common.delete.failure': 'Usuwanie nie powiodło się',
  'common.delete.success': 'Usunięto pomyślnie',
  'common.deselect': 'Odznacz',
  'common.deselectAll': 'Odznacz wszystkie',
  'common.device': 'Urządzenie',
  'common.devices': 'Urządzenia',
  'common.download': 'Pobierz',
  'common.edit': 'Edytuj',
  'common.edit.failure': 'Edycja nie powiodła się',
  'common.edit.success': 'Edytowano pomyślnie',
  'common.email': 'Email',
  'common.email.validation': 'Proszę podać poprawny adres email',
  'common.feature': 'Cecha',
  'common.fetch.failure': 'Nie udało się pobrać danych',
  'common.imageAngle': 'Kąt zdjęcia',
  'common.images': 'Zdjęcia',
  'common.logout': 'Wyloguj się',
  'common.name': 'Nazwa',
  'common.no': 'Nie',
  'common.noDefects': 'Brak wad',
  'common.percentages': 'Procenty',
  'common.phone': 'Telefon',
  'common.pieces': 'Sztuki',
  'common.preview': 'Podgląd',
  'common.reload': 'Odśwież',
  'common.removeAll': 'Usuń wszystkie',
  'common.required': 'To pole jest wymagane',
  'common.reset': 'Reset',
  'common.samples_count': 'Liczba próbek',
  'common.search': 'Wyszukaj',
  'common.select': 'Zaznacz',
  'common.selectedDate': 'Wybrana data',
  'common.sorting': 'Sortowanie',
  'common.sorting.ascending': 'Rosnąco',
  'common.sorting.descending': 'Malejąco',
  'common.sorting.timestamp.ascending': 'Od najstarszych',
  'common.sorting.timestamp.descending': 'Od najnowszych',
  'common.specificName': 'Nazwa: {name}',
  'common.table': 'Tabela',
  'common.timeline': 'Oś czasu',
  'common.timeRange': 'Zakres czasu',
  'common.units': 'Wyświetlane jednostki',
  'common.update.success': 'Zaktualizowano pomyślnie',
  'common.upload': 'Prześlij plik',
  'common.yes': 'Tak',
  'dashboard.defectSummary': 'Podsumowanie defektów',
  'dashboard.detectedDefects': 'Wykryte defekty',
  'dashboard.inspections': 'Wykonane inspekcje',
  'dashboard.latestInspections': 'Najnowsze inspekcje',
  'dashboard.latestIssues': 'Ostatnie błędy',
  'dashboard.nextDay': 'Następny dzień',
  'dashboard.noData': 'Brak wpisów na wybraną datę',
  'dashboard.previousDay': 'Poprzedni dzień',
  'dashboard.prodErrors': 'Błędy produkcji',
  'dashboard.rejectionRate': 'Procent odrzuceń',
  'dashboard.rejectionRate.description': 'Przypadki wystąpienia tego samego rodzaju błędu trzy razy pod rząd',
  'dashboard.rejections': 'Odrzucono',
  'dashboard.successfulInspections': 'Pomyślne inspekcje',
  'dashboard.summary': 'Podsumowanie',
  'dashboard.table.description': 'Opis',
  'dashboard.table.socket': 'Gniazdo',
  'dashboard.table.status': 'Status',
  'dashboard.table.timestamp': 'Data',
  'generateReport': 'Wygeneruj raport',
  'generateReport.addedCharts': 'Wykresy dodane do raportu',
  'generateReport.addImage': 'Zaznaczono zdjęcie do raportu',
  'generateReport.download': 'Pobierz raport',
  'generateReport.duplicateName': 'Raport o takiej nazwie już istnieje. Proszę podać inną nazwę.',
  'generateReport.failure': 'Nie udało się wygenerować raportu',
  'generateReport.name': 'Nazwa raportu',
  'generateReport.noSelectedImages': 'Nie zaznaczono zdjęć',
  'generateReport.removeImage': 'Usunięto zdjęcie z raportu',
  'generateReport.selectedImages': 'Zaznaczone zdjęcia',
  'generateReport.success': 'Raport wygenerowany pomyślnie',
  'menu.alerts': 'Alerty',
  'menu.alerts.contacts': 'Kontakty',
  'menu.alerts.logs': 'Historia',
  'menu.dashboard': 'Podsumowanie',
  'menu.devices': 'Urządzenia',
  'menu.home': 'Home',
  'menu.classLabels': 'ClassLabel',
  'menu.labels': 'Etykiety',
  'menu.reports': 'Raporty',
  'menu.samples': 'Analiza próbek',
  'menu.settings': 'Ustawienia',
  'menu.thresholds': 'Progi akceptacji wad',
  'menu.users': 'Użytkownicy',
  'page.alerts.addContact': 'Dodaj kontakt',
  'page.alerts.deleteContact': 'Usuń kontakt',
  'page.alerts.deleteContact.description': 'Czy na pewno chcesz usunąć ten kontakt?',
  'page.alerts.editContact': 'Edytuj kontakt',
  'page.devices.currentDefectSetName': 'Aktualny zestaw wad: <b>{name}</b>',
  'page.devices.supportLabels': 'Obsługuje etykiety:',
  'page.labels.addLabel': 'Dodaj etykietę',
  'page.labels.deleteLabel': 'Usuń etykietę',
  'page.labels.deleteLabel.description': 'Czy na pewno chcesz usunąć etykietę?',
  'page.labels.devices': 'Urządzenia',
  'page.labels.editLabel': 'Edytuj etykietę',
  'page.labels.timestamp': 'Data',
  'page.classLabels.add.title': 'Dodaj klasę',
  'page.classLabels.defectSet': 'Zestaw defektów',
  'page.classLabels.delete.description': 'Czy na pewno chcesz usunąć tę klasę?',
  'page.classLabels.delete.failure': 'Nie można usunąć klasy, która zawiera próbki.',
  'page.classLabels.delete.title': 'Usuń klasę',
  'page.classLabels.edit.failure': 'Nie udało się zapisać zmian',
  'page.classLabels.edit.success': 'Zapisano zmiany',
  'page.classLabels.edit.title': 'Edytuj klasę',
  'page.classLabels.empty': 'Brak utworzonych klas',
  'page.classLabels.name': 'Nazwa klasy',
  'page.classLabels.picker.confirm': 'Dodaj wybrane ({count})',
  'page.classLabels.picker.empty': 'Brak zdjęć dla wybranych filtrów',
  'page.classLabels.picker.open': 'Wybierz zdjęcia',
  'page.classLabels.picker.selected': 'Wybrano: {count}',
  'page.classLabels.picker.title': 'Wybór zdjęć do zbioru uczącego',
  'page.classLabels.referenceImages': 'zdjęcia referencyjne',
  'page.classLabels.save.failure': 'Nie udało się zapisać klasy',
  'page.classLabels.save.success': 'Zapisano klasę',
  'page.classLabels.trainingSet': 'Zbiór uczący zawiera',
  'page.classLabels.trainingSet.count': '{count} zdjęć',
  'page.reports.cannotDelete': 'Nie możesz usunąć raportu innego użytkownika.',
  'page.reports.copyLink.failure': 'Nie udało się skopiować linku',
  'page.reports.copyLink.success': 'Pomyślnie skopiowano link, będzie on aktywny przez następne 24 godziny',
  'page.reports.copyLink.title': 'Kopiuj link',
  'page.reports.delete.description': 'Czy na pewno chcesz usunąć ten raport?',
  'page.reports.delete.title': 'Usuń raport',
  'page.reports.download.failure': 'Nie udało się pobrać raportu',
  'page.reports.generatedBy': 'Wygenerowane przez',
  'page.samples.noSamples': 'Brak wpisów na wybrany zakres dat',
  'page.settings.complaintThresholdEnabled': 'Włącz próg reklamacyjny',
  'page.settings.endTime': 'Czas zakończenia pracy',
  'page.settings.startTime': 'Czas rozpoczęcia pracy',
  'page.thresholds.addThreshold': 'Dodaj próg',
  'page.thresholds.defect': 'Obsługiwane wady',
  'page.thresholds.deleteThreshold': 'Usuń próg',
  'page.thresholds.deleteThreshold.description': 'Czy na pewno chcesz usunąć ten próg?',
  'page.thresholds.deleteThreshold.error': 'Nie można usunąć progu, ponieważ jest on używany przez co najmniej jedno urządzenie.',
  'page.thresholds.editThreshold': 'Edytuj próg',
  'page.thresholds.thresholdName': 'Nazwa progu',
  'page.thresholds.values': 'Wartości wad',
  'page.thresholds.warning.description': 'Tylko uprawnieni użytkownicy rozumiejący na czym polega dobór progów powinni modyfikować zaprezentowane wartości. <b>Mają one wpływ na działanie całego systemu, nie tylko dla jednego użytkownika</b>.\nZmiana progów ma natychmiastowy wpływ na dane prezentowane na stronie oraz wszystkie raporty wygenerowane po tej zmianie. <b>Raporty w plikach .pdf wygenerowane wcześniej nie zostaną zmienione</b>.',
  'page.thresholds.warning.title': 'Uwaga!',
  'page.users.addUser': 'Dodaj użytkownika',
  'page.users.deleteUser': 'Usuń użytkownika',
  'page.users.deleteUser.description': 'Czy na pewno chcesz usunąć użytkownika?',
  'page.users.deleteUser.tooltip': 'Nie możesz usunąć swojego konta',
  'page.users.editUser': 'Edytuj użytkownika',
  'page.users.firstName': 'Imię',
  'page.users.lastName': 'Nazwisko',
  'page.users.password': 'Hasło',
  'page.users.permissions': 'Uprawnienia',
  'pages.403.buttonText': 'Wróć na stronę główną',
  'pages.403.subTitle': 'Przepraszamy, nie masz uprawnień do dostępu do tej strony.',
  'pages.404.buttonText': 'Wróć na stronę główną',
  'pages.404.subTitle': 'Przepraszamy, strona, której szukasz, nie istnieje.',
  'pages.login.badRequest': 'Nieprawidłowe dane logowania',
  'pages.login.failure': 'Logowanie nie powiodło się',
  'pages.login.password.placeholder': 'Hasło',
  'pages.login.subTitle': 'Zaloguj się',
  'permissions.alerts': 'Alerty',
  'permissions.class_labels': 'ClassLabel',
  'permissions.current_data': 'Aktualne dane',
  'permissions.devices': 'Urządzenia',
  'permissions.labels': 'Etykiety',
  'permissions.manage_class_labels': 'Zarządzanie ClassLabel',
  'permissions.manage_labels': 'Zarządzanie etykietami',
  'permissions.reports': 'Raporty',
  'permissions.samples': 'Analiza próbek',
  'permissions.settings': 'Ustawienia',
  'permissions.system_status': 'Status systemu',
  'permissions.thresholds': 'Progi akceptacji wad',
  'permissions.uploads': 'Przesyłanie plików',
  'permissions.users': 'Użytkownicy',
  'placeholder.select.multiple': 'Wybierz kilka',
  'threshold.complaint': 'Próg reklamacyjny',
  'threshold.production': 'Próg produkcyjny',
  'unauthorized.description': 'Proszę zalogować się ponownie, aby kontynuować.',
  'unauthorized.title': 'Twoja sesja wygasła',
};
